import { DEFAULT_REPORT_LOOKBACK_DAYS } from '../components/pages-equipment/equipmentConstants';
import type { ReportFilterValues } from '../components/reports/ReportFilterBar';

export const REPORT_FILTER_STORAGE_KEYS = {
    inspection: 'report-filters-inspection',
    dailyService: 'report-filters-daily-service',
    shift: 'report-filters-shift',
} as const;

export type UnitReportsTabId = 'standard' | 'custom' | 'inspection' | 'daily-service' | 'shift';

const RESERVED_REPORT_PATH_SEGMENTS = new Set(['standard', 'custom']);

export const isReservedReportsPathSegment = (segment: string): boolean =>
    RESERVED_REPORT_PATH_SEGMENTS.has(segment);

export const buildDefaultUnitReportDateStart = (): string => {
    const defaultStart = new Date();
    defaultStart.setDate(defaultStart.getDate() - DEFAULT_REPORT_LOOKBACK_DAYS);
    return `${defaultStart.getFullYear()}-${String(defaultStart.getMonth() + 1).padStart(2, '0')}-${String(defaultStart.getDate()).padStart(2, '0')}`;
};

export const buildUnitReportFilters = (
    equipmentCategoryId: string,
    unitId: string,
): ReportFilterValues => ({
    equipmentCategoryId,
    unitId,
    dateStart: buildDefaultUnitReportDateStart(),
    dateEnd: '',
    locationId: '',
    districtId: '',
    regionId: '',
});

export const seedUnitReportFilters = (equipmentCategoryId: string, unitId: string): void => {
    const filters = buildUnitReportFilters(equipmentCategoryId, unitId);
    try {
        sessionStorage.setItem(REPORT_FILTER_STORAGE_KEYS.inspection, JSON.stringify(filters));
        sessionStorage.setItem(REPORT_FILTER_STORAGE_KEYS.dailyService, JSON.stringify(filters));
    } catch {
        /* ignore quota */
    }
};

export const buildUnitReportsPath = (
    unitId: string,
    options?: { tab?: UnitReportsTabId; equipmentCategoryId?: string },
): string => {
    const params = new URLSearchParams();
    if (options?.tab) {
        params.set('tab', options.tab);
    }
    if (options?.equipmentCategoryId) {
        params.set('categoryId', options.equipmentCategoryId);
    }
    const query = params.toString();
    return query ? `/reports/${unitId}?${query}` : `/reports/${unitId}`;
};

/** Company-wide Reports landing path with an optional tab query. */
export const buildCompanyReportsPath = (options?: { tab?: UnitReportsTabId }): string => {
    if (!options?.tab) return '/reports';
    return `/reports?tab=${encodeURIComponent(options.tab)}`;
};

export const buildInspectHubPath = (equipmentCategoryId: string, unitId: string): string =>
    `/inspect/${equipmentCategoryId}?unitId=${unitId}`;

export type ReportDetailReturnState = {
    returnTo: string;
    returnLabel?: string;
};
